module.exports = __webpack_public_path__ + "img/GBPJPY.da6c88ab.png";